// extracted by css-extract-rspack-plugin
export default {"input":"Z1SZz","section":"PyyCf"};